import React from 'react'
import _ from 'lodash'

const CDN_URL = 'https://4wi83c2lj5.execute-api.us-west-2.amazonaws.com/prod/redirector?key='
const FULL_SIZE = '1200x1200'
const PINTEREST_SIZE = '750x750'

export class ImageGrid extends React.Component {
    constructor(props) {
        super(props)

        let slideImages = this.props.images.filter((img) => img.get('filename')).sort((img1, img2) => {
            if (img1.get('sort') < img2.get('sort')) {
                return -1
            }
            if (img1.get('sort') === img2.get('sort')) {
                return 0
            }
            if (img1.get('sort') > img2.get('sort')) {
                return 1
            }
        })

        this.state = {
            imgCount: slideImages.size,
            images: slideImages,
        }
        _.bindAll(this,
            'setGridHeight',
            'filterSlideImages',
            'formatImages',
            'getLayout'
        )
    }

    filterSlideImages(images) {
        let slideImages = []

        if (images) {
            slideImages = images.filter((img) => {
                if (typeof img !== 'string') {
                    return img.getIn(['pivot', 'in_slideshow'])
                } else {
                    return false
                }
            })
        }

        if (slideImages.size > 0) {
            slideImages = slideImages.sortBy((img) => {
                return img.getIn(['pivot', 'slideshow_index'])
            })
        }

        return slideImages
    }

    componentDidMount() {
        $.fancybox.defaults.image.protect = true
        $.fancybox.defaults.margin = [44, 0, 100, 0]
        window.addEventListener('resize', () => {
            this.setGridHeight()
        })
        this.setGridHeight()
    }

    componentWillReceiveProps(nextProps) {
        let slideImages = this.filterSlideImages(nextProps.images)
        if (slideImages.size !== this.state.images.size) {
            this.setState({images: slideImages, imgCount: slideImages.size})
        }
    }

    setGridHeight() {
        let cW = $('.image-grid').outerWidth()
        let nH = 0
        if (this.state.imgCount > 1) {
            nH = cW * 9 / 16 * .618 // See CSS, Using Golden ratio to set width of first image
        } else if (this.state.imgCount === 1) {
            nH = cW * 9 / 16
        }
        // setting both as the grid will animate to reveal the wrapper with a css transform
        $('.image-grid-wrapper').height(nH)
        $('.image-grid').height(nH)
    }

    formatImages() {
        let imageCount = this.state.imgCount
        return this.state.images.map((img, index) => {
            // Get data
            let hasHttp = img.get('filename').substring(0, 4) == 'http'
            let imgPath = hasHttp ? img.get('filename') : '/' + img.get('filename')
            let imgSmall = ''
            let imgPrefixSmall = hasHttp ? '' : CDN_URL
            let imgLarge = hasHttp ? imgPath : CDN_URL + FULL_SIZE + imgPath
            if (imgLarge.indexOf('maxwidth=800') > -1) {
                imgLarge = imgLarge.replace('maxwidth=800', 'maxwidth=2400')
            }

            switch (index) {
                case 0:
                    // either full or half, but image is always the same size
                    imgSmall = hasHttp ? imgPath : imgPrefixSmall + '1300x700' + imgPath
                    if (imageCount == 1) {
                        return <a data-fancybox="luna-gallery" data-type="image" href={imgLarge}
                                  data-caption={this.getCaption(img)} data-index={index} className="image feature-solo"
                                  style={{'backgroundImage': 'url(' + imgSmall + ')'}}/>
                    } else {
                        return <a data-fancybox="luna-gallery" data-type="image" href={imgLarge}
                                  data-caption={this.getCaption(img)} data-index={index} className="image feature-combo"
                                  style={{'backgroundImage': 'url(' + imgSmall + ')'}}/>
                    }
                    break
                case 1:
                    // either large square, rectangle, or small square
                    if (imageCount == 2) {
                        // lg square
                        imgSmall = hasHttp ? imgPath : imgPrefixSmall + '500x500' + imgPath
                        return <a data-fancybox="luna-gallery" data-type="image" href={imgLarge}
                                  data-caption={this.getCaption(img)} data-index={index}
                                  className="image square square-medium"
                                  style={{'backgroundImage': 'url(' + imgSmall + ')'}}/>
                    } else if (imageCount == 3) {
                        // rect
                        imgSmall = hasHttp ? imgPath : imgPrefixSmall + '500x250' + imgPath
                        return <a data-fancybox="luna-gallery" data-type="image" href={imgLarge}
                                  data-caption={this.getCaption(img)} data-index={index} className="image rect-small"
                                  style={{'backgroundImage': 'url(' + imgSmall + ')'}}/>
                    } else {
                        // sm square
                        imgSmall = hasHttp ? imgPath : imgPrefixSmall + '250x250' + imgPath
                        return <a data-fancybox="luna-gallery" data-type="image" href={imgLarge}
                                  data-caption={this.getCaption(img)} data-index={index} className="image square-small"
                                  style={{'backgroundImage': 'url(' + imgSmall + ')'}}/>
                    }
                    break
                case 2:
                    // either rectangle or small square
                    if (imageCount == 3) {
                        // rect
                        imgSmall = hasHttp ? imgPath : imgPrefixSmall + '500x250' + imgPath
                        return <a data-fancybox="luna-gallery" data-type="image" href={imgLarge}
                                  data-caption={this.getCaption(img)} data-index={index} className="image rect-small"
                                  style={{'backgroundImage': 'url(' + imgSmall + ')'}}/>
                    } else {
                        // sm square
                        imgSmall = hasHttp ? imgPath : imgPrefixSmall + '250x250' + imgPath
                        return <a data-fancybox="luna-gallery" data-type="image" href={imgLarge}
                                  data-caption={this.getCaption(img)} data-index={index} className="image square-small"
                                  style={{'backgroundImage': 'url(' + imgSmall + ')'}}/>
                    }
                    break
                case 3:
                    // either rectangle or small square
                    if (imageCount == 4) {
                        // rect
                        imgSmall = hasHttp ? imgPath : imgPrefixSmall + '500x250' + imgPath
                        return <a data-fancybox="luna-gallery" data-type="image" href={imgLarge}
                                  data-caption={this.getCaption(img)} data-index={index} className="image rect-small"
                                  style={{'backgroundImage': 'url(' + imgSmall + ')'}}/>
                    } else {
                        // sm square
                        imgSmall = hasHttp ? imgPath : imgPrefixSmall + '250x250' + imgPath
                        return <a data-fancybox="luna-gallery" data-type="image" href={imgLarge}
                                  data-caption={this.getCaption(img)} data-index={index} className="image square-small"
                                  style={{'backgroundImage': 'url(' + imgSmall + ')'}}/>
                    }
                    break
                case 4:
                    // always small square but may have overlay text
                    imgSmall = hasHttp ? imgPath : imgPrefixSmall + '250x250' + imgPath
                    if (imageCount == 5) {
                        return <a data-fancybox="luna-gallery" data-type="image" href={imgLarge}
                                  data-caption={this.getCaption(img)} data-index={index} className="image square-small"
                                  style={{'backgroundImage': 'url(' + imgSmall + ')'}}/>
                    } else {
                        return <a data-fancybox="luna-gallery" data-type="image" href={imgLarge}
                                  data-caption={this.getCaption(img)} data-index={index}
                                  className="image square-small image-more"
                                  style={{'backgroundImage': 'url(' + imgSmall + ')'}}><span>See More Photos</span></a>
                    }
                    break
                default:
                    // hidden
                    return <a key={index} data-fancybox="luna-gallery" data-type="image"
                              data-caption={this.getCaption(img)} href={imgLarge} className="hidden"/>
                    break
            }
        })
    }


    getCaption(item) {
        let title = this.props.title ? '<h2>' + this.props.title + '</h2>' : ''
        let copy = ''
        if (typeof item.get('copyright') === 'string') {
            copy = item.get('copyright') ? '<span>' + item.get('copyright') + '</span>' : ''
        } else {
            // it's google....
            let tCopy = item.getIn(['copyright', 0]) ? '<span>' + item.getIn(['copyright', 0]) + '</span>' : ''
            copy = tCopy.replace(/href=/g, ' target="_blank" href=')
        }

        let desc = ''
        if (item.getIn(['pivot', 'description'])) {
            desc = item.getIn(['pivot', 'description'])
        } else if (item.get('title')) {
            desc = item.get('title')
        }
        return '<div>' + title + desc + copy + '</div>'
    }

    getLayout() {
        let formattedImages = this.formatImages()
        if (formattedImages.size < 3) {
            return (
                <div className="image-grid-wrapper">
                    {formattedImages.get(0)}
                    {formattedImages.get(1)}
                </div>
            )
        } else {
            let extraImages = null
            let extraObjs = null
            if (formattedImages.size > 5) {
                extraImages = formattedImages.filter((img, index) => {
                    return index > 4
                })
                extraObjs = extraImages.map((img, index) => {
                    return img
                })
            }
            return (
                <div className="image-grid-wrapper">
                    {formattedImages.get(0)}
                    <div className="image square">
                        {formattedImages.get(1)}
                        {formattedImages.get(2)}
                        {formattedImages.get(3)}
                        {formattedImages.get(4)}
                    </div>
                    {extraObjs}
                </div>
            )
        }
    }

    getPinterestImages() {
        let images = this.state.images.filter((img) => {
            return img.get('filename').substring(0, 4) !== 'http'
        }).slice(0, 5).map((img, i) =>{
            let src = CDN_URL + PINTEREST_SIZE + '/' + img.get('filename')
            let alt = img.get('alt')
            return (<img key={i} src={src} alt={alt}/>)
        })
        return (
            <div style={{display: 'none'}}>
                {images}
            </div>
        )
    }


    render() {
        if (this.state.imgCount > 0) {
            return (
                <div>
                    <div className="image-grid">
                        {this.getLayout()}
                    </div>
                    {this.getPinterestImages()}
                </div>
            )
        } else {
            return null
        }
    }
}
